module.exports = __webpack_public_path__ + "static/media/view1.8e91dc8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view1.png
// module id = 223
// module chunks = 0